__turbopack_context__.v({
  "multi-range-slider": "multiRangeSlider-component-module-scss-module__fVZtJa__multi-range-slider",
  "slider": "multiRangeSlider-component-module-scss-module__fVZtJa__slider",
  "slider-container": "multiRangeSlider-component-module-scss-module__fVZtJa__slider-container",
  "slider__input": "multiRangeSlider-component-module-scss-module__fVZtJa__slider__input",
  "slider__input-content": "multiRangeSlider-component-module-scss-module__fVZtJa__slider__input-content",
  "slider__input-separator": "multiRangeSlider-component-module-scss-module__fVZtJa__slider__input-separator",
  "slider__input-wrapper": "multiRangeSlider-component-module-scss-module__fVZtJa__slider__input-wrapper",
  "slider__range": "multiRangeSlider-component-module-scss-module__fVZtJa__slider__range",
  "slider__track": "multiRangeSlider-component-module-scss-module__fVZtJa__slider__track",
  "slider__values": "multiRangeSlider-component-module-scss-module__fVZtJa__slider__values",
  "thumb": "multiRangeSlider-component-module-scss-module__fVZtJa__thumb",
  "thumb--left": "multiRangeSlider-component-module-scss-module__fVZtJa__thumb--left",
  "thumb--right": "multiRangeSlider-component-module-scss-module__fVZtJa__thumb--right",
});
